import React from 'react';
import Navbar from './Navbar';
import Demo from './Demo';
import Footer from './Footer';

const DemoPage = () => {
  return (
    <div className="demo-page">
      <Navbar />
      <Demo />
      <Footer />
    </div>
  );
};

export default DemoPage;
